import React from 'react'
import { FaPlus } from 'react-icons/fa'
import { CustomDropdown, InputText, TextBtn } from '../../../../components'
import AcoesLinha from './AcoesLinha'
import {
  adicionarOpcao,
  alterarOpcao,
  LIMITES,
  mover,
  removerOpcao,
  RESULTADOS,
} from './checklist.util'

const styles = {
  linha: { display: 'flex', alignItems: 'flex-end', gap: 10 },
  label: { flex: 1 },
  resultado: { width: 160 },
  acoes: { paddingBottom: 2 },
}

export default function OpcoesResposta({ opcoes, comResultado, onChange }) {
  const lista = opcoes || []

  return (
    <div>
      {lista.map((opcao, indice) => (
        <div key={opcao.id} style={styles.linha}>
          <div style={styles.label}>
            <InputText
              label={`Opção ${indice + 1}:*`}
              marginTop={8}
              maxLength={LIMITES.rotulo}
              value={opcao.label}
              onChange={value => onChange(alterarOpcao(lista, opcao.id, 'label', value))}
            />
          </div>
          {comResultado ? (
            <div style={styles.resultado}>
              <CustomDropdown
                label="Classificação:*"
                marginTop={8}
                optionLabel="label"
                options={RESULTADOS}
                value={RESULTADOS.find(resultado => resultado.value === opcao.result) || null}
                onChange={value =>
                  onChange(alterarOpcao(lista, opcao.id, 'result', value ? value.value : null))
                }
              />
            </div>
          ) : null}
          <div style={styles.acoes}>
            <AcoesLinha
              primeiro={indice === 0}
              ultimo={indice === lista.length - 1}
              podeRemover={lista.length > LIMITES.minOpcoes}
              onMover={direcao => onChange(mover(lista, opcao.id, direcao))}
              onRemover={() => onChange(removerOpcao(lista, opcao.id))}
            />
          </div>
        </div>
      ))}
      {lista.length < LIMITES.maxOpcoes ? (
        <div style={{ marginTop: 8 }}>
          <TextBtn onClick={() => onChange(adicionarOpcao(lista, comResultado))}>
            <FaPlus size={10} style={{ marginRight: 5 }} />
            Adicionar opção
          </TextBtn>
        </div>
      ) : null}
    </div>
  )
}
